import { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import Upload from './upload';
import Urls from './urls';
import {
  Icon,
  TabsNavigation,
  Button,
  Container,
} from './styles';
import Slider from '../../slider';
import { getUser as getUserSelector } from '../../../../store/users/selectors';

const TABS = {
  UPLOAD: 'upload',
  LINK: 'link',
  GOOGLE_DRIVE: 'drive',
};

const FileUpload = ({
  onUpload, isLoading, newImageData, onReset, newImageByUrlData, onImageUrlUpload, onResetImageUrl,
}) => {
  const [currentTab, setCurrentTab] = useState(TABS.UPLOAD);
  const user = useSelector(getUserSelector);
  const {
    control, formState, setValue, watch, register, trigger, getValues,
  } = useFormContext();
  const clickCurrentTab = (tab) => {
    setCurrentTab(tab);
  };

  const images = watch('files');

  useEffect(() => {
    trigger('files');
  }, [images.length]);

  useEffect(() => {
    if (!isLoading) {
      if (newImageData && !images.find(({ id: imgId }) => imgId === newImageData?.id)) {
        const { id, code, extension } = newImageData;
        const url = `/storage/images/${user.id}/${code}.${extension}`;

        setValue('files', [...images, { id: parseInt(id, 10), url, created_at: new Date() }]);

        setValue('images', []);
        if(newImageData) {
          onReset();
        }
      } else if (newImageByUrlData && !images.find(({ id: imgId }) => imgId === newImageByUrlData?.id)) {
        const {
          id, code, extension, originalUrl,
        } = newImageByUrlData;
        const url = `/storage/images/${user.id}/${code}.${extension}`;

        setValue('files', [...images, {
          id: parseInt(id, 10),
          url,
          created_at: new Date(),
          originalUrl,
        }]);

        if(newImageByUrlData) {
          onResetImageUrl();
        }
      }
    }
  }, [isLoading, newImageData, newImageByUrlData]);

  useEffect(() => () => {
    onResetImageUrl();
    onReset();

    setValue('files', []);
    setValue('urls', [{ value: '', storageId: '' }]);
    setValue('images', []);
  }, []);

  const handleDelete = (id) => {
    setValue('files', images.filter(({ id: imgId }) => imgId !== id));
    setValue('urls', getValues('urls').filter(({ storageId }) => storageId !== id));
  };

  return (
    <Container>
      <Slider
        data={images}
        isEditable
        onItemRemove={handleDelete}
      />
      <TabsNavigation>
        <Button
          isActive={currentTab === TABS.UPLOAD}
          onClick={() => clickCurrentTab(TABS.UPLOAD)}
        >
          <Icon className="icon-cloud-upload" />
          Pick from computer
        </Button>
        <Button
          isActive={currentTab === TABS.LINK}
          onClick={() => clickCurrentTab(TABS.LINK)}
        >
          <Icon className="icon-link" />
          Paste URL(s)
        </Button>
      </TabsNavigation>
      {
        currentTab === TABS.UPLOAD ? (
          <Upload
            name="images"
            control={control}
            onUpload={onUpload}
            isLoading={isLoading}
          />
        ) : null
      }
      {
        currentTab === TABS.LINK ? (
          <Urls
            onUpload={onImageUrlUpload}
            name="urls"
            control={control}
            isValid={formState.isValid}
            isLoading={isLoading}
            onDelete={handleDelete}
            data={newImageByUrlData}
            images={images}
          />
        ) : null
      }
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <input {...register('files')} type="hidden" defaultValue={[]} />
    </Container>
  );
};

export default FileUpload;
